export enum FormMessagesEnum {
  REQUIRED = 'REQUIRED',
  EMAIL = 'EMAIL',
  MAX_LENGTH = 'MAX_LENGTH',
  MIN_LENGTH = 'MIN_LENGTH',
}
